import { Fragment } from 'react';
import { createPortal } from 'react-dom';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon, XCircleIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { XMarkIcon } from '@heroicons/react/20/solid';

export default function Notification({ showSavedNotification = false, setShowSavedNotification, title, desc, status }) {
    const notification = (
        <>
            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live='assertive'
                className='flex fixed inset-0 z-50 items-end px-4 py-6 pointer-events-none sm:items-start sm:p-6'
            >
                <div className='flex flex-col items-center space-y-4 w-full sm:items-end'>
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={showSavedNotification}
                        as={Fragment}
                        enter='transform ease-out duration-300 transition'
                        enterFrom='translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2'
                        enterTo='translate-y-0 opacity-100 sm:translate-x-0'
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                    >
                        <div className='overflow-hidden w-full max-w-sm bg-white rounded-lg ring-1 ring-black ring-opacity-5 shadow-lg pointer-events-auto'>
                            <div className='p-4'>
                                <div className='flex items-start'>
                                    <div className='flex-shrink-0'>
                                        {status === 'success' ? (
                                            <CheckCircleIcon className='w-6 h-6 text-green-400' aria-hidden='true' />
                                        ) : status === 'error' ? (
                                            <XCircleIcon className='w-6 h-6 text-red-400 animate-pulse' aria-hidden='true' />
                                        ) : status === 'question' ? (
                                            <QuestionMarkCircleIcon className='w-6 h-6 text-blue-600' aria-hidden='true' />
                                        ) : null}
                                    </div>
                                    <div className='flex-1 pt-0.5 ml-3 w-0'>
                                        <p className='text-sm font-medium text-gray-900'>{title}</p>
                                        <p className='mt-1 text-sm text-gray-500'>{desc}</p>
                                    </div>
                                    <div className='flex flex-shrink-0 ml-4'>
                                        <button
                                            type='button'
                                            className='inline-flex text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
                                            onClick={() => {
                                                setShowSavedNotification(false);
                                            }}
                                        >
                                            <span className='sr-only'>Close</span>
                                            <XMarkIcon className='w-5 h-5' aria-hidden='true' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </>
    );

    return createPortal(notification, document.body);
}
